export class LimitPair<T> {
  constructor(public min: T, public max: T) {
  }

  clone(): LimitPair<T> {
    return new LimitPair<T>(
      this.min,
      this.max
    );
  }
}
